// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3tHIn","buttons":"Footer_buttons__3GQ9R"};